// extracted by mini-css-extract-plugin
export default {"root":"style_root__KBVuG","headerIcon":"style_headerIcon__85OEJ","middlePart":"style_middlePart__6+UwE","subtitle":"style_subtitle__K+kb6"};